







import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ProductRow extends Vue {
  @Prop({ type: String, default: "" })
  title!: string;
}
